import { fetchCountries } from 'api';
import useAxios from 'hooks/useAxios';

const useFetchCountries = () => {
  const [request, { loading, error, data }] = useAxios<{ name: string; iso2: string }[]>();

  const handleFetchCountries = async () => {
    const countries = await request(fetchCountries());

    return countries;
  };

  return [handleFetchCountries, { loading, error: error?.data?.message, data }] as const;
};

export { useFetchCountries };
